import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "d-flex align-center px-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-center text-muted py-6"
}
const _hoisted_3 = { class: "font-weight-medium" }
const _hoisted_4 = {
  key: 0,
  class: "text-caption text-medium-emphasis ml-1"
}
const _hoisted_5 = { class: "question-cell" }
const _hoisted_6 = { class: "text-caption text-medium-emphasis" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_8 = {
  key: 1,
  class: "text-medium-emphasis text-caption"
}
const _hoisted_9 = {
  key: 0,
  class: "text-center text-muted py-6"
}
const _hoisted_10 = { class: "font-weight-medium" }
const _hoisted_11 = {
  key: 1,
  class: "text-medium-emphasis text-caption"
}
const _hoisted_12 = { class: "d-flex align-center" }
const _hoisted_13 = {
  key: 0,
  class: "text-caption"
}
const _hoisted_14 = {
  key: 1,
  class: "text-medium-emphasis text-caption"
}
const _hoisted_15 = { class: "text-caption text-medium-emphasis" }
const _hoisted_16 = {
  key: 0,
  class: "text-center text-muted py-6"
}
const _hoisted_17 = { class: "font-weight-medium" }
const _hoisted_18 = {
  key: 1,
  class: "text-medium-emphasis text-caption"
}
const _hoisted_19 = { class: "text-caption" }
const _hoisted_20 = {
  key: 0,
  class: "d-flex align-center"
}
const _hoisted_21 = {
  key: 1,
  class: "text-medium-emphasis text-caption"
}
const _hoisted_22 = { class: "text-caption text-medium-emphasis" }
const _hoisted_23 = { class: "d-flex align-center mb-3 text-caption text-medium-emphasis" }
const _hoisted_24 = {
  class: "text-body-2 mb-0",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = {
  key: 1,
  class: "text-medium-emphasis text-caption"
}

import { computed, ref } from 'vue'
import { marked } from 'marked'
import { useRouter } from 'vue-router'
import { downloadXlsx } from '@/utils/exportXlsx'
import type { RecentQuestion, LowRatedQuestion, RecentComment } from '@/services/adminStatsApi'


export default /*@__PURE__*/_defineComponent({
  __name: 'StatsRecentActivity',
  props: {
    recentQuestions: {},
    lowRated: {},
    recentComments: {}
  },
  setup(__props: any) {

const props = __props

const tab = ref('questions')
const router = useRouter()

const dialog = ref(false)
const selected = ref<RecentQuestion | LowRatedQuestion | null>(null)

function openDetail(item: RecentQuestion | LowRatedQuestion) {
  selected.value = item
  dialog.value = true
}

function openFullPage() {
  if (!selected.value?.conversation_id) return
  dialog.value = false
  router.push({ path: '/apps/decisions-ai', query: { conversation_id: String(selected.value.conversation_id) } })
}

function goToUser(username: string | null) {
  if (!username) return
  dialog.value = false
  router.push({ path: `/admin/users/${username}/questions` })
}

function renderMarkdown(text: string): string {
  return marked.parse(text) as string
}

function formatDate(dt: string): string {
  if (!dt) return '—'
  return new Date(dt).toLocaleString('tr-TR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

const questionHeaders = [
  { title: 'Kullanıcı', key: 'user_name', width: '180px' },
  { title: 'Soru', key: 'question' },
  { title: 'Tarih', key: 'asked_at', width: '140px' },
  { title: 'Puan', key: 'rating', width: '120px', sortable: false },
]

const lowRatedHeaders = [
  { title: 'Kullanıcı', key: 'user_name', width: '160px' },
  { title: 'Soru', key: 'question' },
  { title: 'Puan', key: 'rating', width: '120px', sortable: false },
  { title: 'Yorum', key: 'comment', width: '200px' },
  { title: 'Tarih', key: 'asked_at', width: '140px' },
]

const commentHeaders = [
  { title: 'Kullanıcı', key: 'user_name', width: '160px' },
  { title: 'Soru', key: 'question', width: '200px' },
  { title: 'Yorum', key: 'comment' },
  { title: 'Puan', key: 'rating', width: '120px', sortable: false },
  { title: 'Tarih', key: 'commented_at', width: '140px' },
]

const tabConfig = {
  questions: {
    sheetName: 'Son Sorular',
    fileSlug: 'son-sorular',
    headers: questionHeaders,
    rows: () => props.recentQuestions.map((q) => ({
      user_name: q.username ? `${q.user_name} (${q.username})` : q.user_name,
      question: q.question_full ?? q.question,
      asked_at: formatDate(q.asked_at),
      rating: q.rating ?? '',
    })),
  },
  low_rated: {
    sheetName: 'Düşük Puanlılar',
    fileSlug: 'dusuk-puanlilar',
    headers: lowRatedHeaders,
    rows: () => props.lowRated.map((q) => ({
      user_name: q.user_name,
      question: q.question_full ?? q.question ?? '',
      rating: q.rating,
      comment: q.comment ?? '',
      asked_at: formatDate(q.asked_at),
    })),
  },
  comments: {
    sheetName: 'Yorumlar',
    fileSlug: 'yorumlar',
    headers: commentHeaders,
    rows: () => props.recentComments.map((c) => ({
      user_name: c.user_name,
      question: c.question ?? '',
      comment: c.comment,
      rating: c.rating ?? '',
      commented_at: formatDate(c.commented_at),
    })),
  },
} as const

const activeTabRows = computed(() => tabConfig[tab.value as keyof typeof tabConfig].rows())

function exportActiveTab() {
  const config = tabConfig[tab.value as keyof typeof tabConfig]
  const today = new Date().toISOString().slice(0, 10)
  downloadXlsx(`${config.fileSlug}_${today}.xlsx`, config.sheetName, config.headers, activeTabRows.value)
}


return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "trezo-card bg-white border-0 shadow-none border-radius mb-0" }, {
    default: _withCtx(() => [
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "v-card-header" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Son Aktiviteler")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_tabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
          color: "#1a5f4a",
          class: "flex-grow-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tab, { value: "questions" }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("Son Sorular", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_tab, { value: "low_rated" }, {
              default: _withCtx(() => [
                _cache[9] || (_cache[9] = _createTextVNode(" Düşük Puanlılar ", -1)),
                (__props.lowRated.length)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      size: "x-small",
                      color: "error",
                      class: "ml-1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.lowRated.length), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_tab, { value: "comments" }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("Yorumlar", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_v_btn, {
          variant: "tonal",
          color: "#1a5f4a",
          size: "small",
          disabled: !activeTabRows.value.length,
          onClick: exportActiveTab
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createElementVNode("span", {
              class: "material-symbols-outlined mr-1",
              style: {"font-size":"16px"}
            }, "download", -1),
            _createTextVNode(" XLS İndir ", -1)
          ]))]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_tabs_window, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tab).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window_item, { value: "questions" }, {
            default: _withCtx(() => [
              (!__props.recentQuestions.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Henüz soru yok "))
                : (_openBlock(), _createBlock(_component_v_data_table, {
                    key: 1,
                    headers: questionHeaders,
                    items: __props.recentQuestions,
                    density: "compact",
                    "items-per-page": 25,
                    "items-per-page-options": [25, 50, 100, 200],
                    "onClick:row": _cache[1] || (_cache[1] = (_, row) => openDetail(row.item)),
                    style: {"cursor":"pointer"}
                  }, {
                    "item.user_name": _withCtx(({ item }) => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(item.user_name), 1),
                      (item.username)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(item.username) + ") ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    "item.question": _withCtx(({ item }) => [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(item.question), 1)
                    ]),
                    "item.asked_at": _withCtx(({ item }) => [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(formatDate(item.asked_at)), 1)
                    ]),
                    "item.rating": _withCtx(({ item }) => [
                      (item.rating)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                              return _createElementVNode("span", {
                                key: i,
                                class: "material-symbols-outlined",
                                style: _normalizeStyle({ fontSize: '16px', color: i <= item.rating ? '#c9a227' : '#ddd' })
                              }, "star", 4)
                            }), 64))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, "—"))
                    ]),
                    _: 1
                  }, 8, ["items"]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, { value: "low_rated" }, {
            default: _withCtx(() => [
              (!__props.lowRated.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Düşük puanlı cevap yok "))
                : (_openBlock(), _createBlock(_component_v_data_table, {
                    key: 1,
                    headers: lowRatedHeaders,
                    items: __props.lowRated,
                    density: "compact",
                    "items-per-page": 25,
                    "items-per-page-options": [25, 50, 100, 200],
                    "onClick:row": _cache[2] || (_cache[2] = (_, row) => openDetail(row.item)),
                    style: {"cursor":"pointer"}
                  }, {
                    "item.user_name": _withCtx(({ item }) => [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(item.user_name), 1)
                    ]),
                    "item.question": _withCtx(({ item }) => [
                      (item.question)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            location: "top",
                            "max-width": "400"
                          }, {
                            activator: _withCtx(({ props: tp }) => [
                              _createElementVNode("span", _mergeProps(tp, { class: "question-cell" }), _toDisplayString(item.question), 17)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(item.question), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createElementBlock("span", _hoisted_11, "—"))
                    ]),
                    "item.rating": _withCtx(({ item }) => [
                      _createElementVNode("span", _hoisted_12, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                          return _createElementVNode("span", {
                            key: i,
                            class: "material-symbols-outlined",
                            style: _normalizeStyle({ fontSize: '16px', color: i <= item.rating ? '#c9a227' : '#ddd' })
                          }, "star", 4)
                        }), 64))
                      ])
                    ]),
                    "item.comment": _withCtx(({ item }) => [
                      (item.comment)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.comment), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, "—"))
                    ]),
                    "item.asked_at": _withCtx(({ item }) => [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(formatDate(item.asked_at)), 1)
                    ]),
                    _: 1
                  }, 8, ["items"]))
            ]),
            _: 1
          }),
          _createVNode(_component_v_tabs_window_item, { value: "comments" }, {
            default: _withCtx(() => [
              (!__props.recentComments.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Henüz yorum yok "))
                : (_openBlock(), _createBlock(_component_v_data_table, {
                    key: 1,
                    headers: commentHeaders,
                    items: __props.recentComments,
                    density: "compact",
                    "items-per-page": 25,
                    "items-per-page-options": [25, 50, 100, 200]
                  }, {
                    "item.user_name": _withCtx(({ item }) => [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(item.user_name), 1)
                    ]),
                    "item.question": _withCtx(({ item }) => [
                      (item.question)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            location: "top",
                            "max-width": "400"
                          }, {
                            activator: _withCtx(({ props: tp }) => [
                              _createElementVNode("span", _mergeProps(tp, { class: "question-cell" }), _toDisplayString(item.question), 17)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(item.question), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createElementBlock("span", _hoisted_18, "—"))
                    ]),
                    "item.comment": _withCtx(({ item }) => [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(item.comment), 1)
                    ]),
                    "item.rating": _withCtx(({ item }) => [
                      (item.rating)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                              return _createElementVNode("span", {
                                key: i,
                                class: "material-symbols-outlined",
                                style: _normalizeStyle({ fontSize: '16px', color: i <= item.rating ? '#c9a227' : '#ddd' })
                              }, "star", 4)
                            }), 64))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_21, "—"))
                    ]),
                    "item.commented_at": _withCtx(({ item }) => [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(formatDate(item.commented_at)), 1)
                    ]),
                    _: 1
                  }, 8, ["items"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: dialog.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialog).value = $event)),
        "max-width": "800",
        scrollable: ""
      }, {
        default: _withCtx(() => [
          (selected.value)
            ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "d-flex align-center pa-4 pb-2" }, {
                    default: _withCtx(() => [
                      _cache[14] || (_cache[14] = _createElementVNode("span", {
                        class: "material-symbols-outlined mr-2",
                        style: {"color":"#1a5f4a"}
                      }, "forum", -1)),
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-body-1 font-weight-medium" }, "Soru & Cevap Detayı", -1)),
                      _createVNode(_component_v_spacer),
                      (selected.value?.conversation_id)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            variant: "tonal",
                            color: "#1a5f4a",
                            size: "small",
                            class: "mr-2",
                            onClick: openFullPage
                          }, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("span", {
                                class: "material-symbols-outlined mr-1",
                                style: {"font-size":"16px"}
                              }, "open_in_full", -1),
                              _createTextVNode(" Tam sayfaya geç ", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        variant: "text",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (dialog.value = false))
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createElementVNode("span", { class: "material-symbols-outlined" }, "close", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_text, {
                    class: "pa-4",
                    style: {"max-height":"70vh","overflow-y":"auto"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", {
                          class: "material-symbols-outlined mr-1",
                          style: {"font-size":"16px"}
                        }, "person", -1)),
                        _createElementVNode("span", {
                          class: "font-weight-medium mr-1 user-link",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (goToUser(selected.value.username)))
                        }, _toDisplayString(selected.value.user_name), 1),
                        (selected.value.username)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "user-link",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (goToUser(selected.value.username)))
                            }, "(" + _toDisplayString(selected.value.username) + ")", 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_spacer),
                        _createElementVNode("span", null, _toDisplayString(formatDate(selected.value.asked_at)), 1),
                        (selected.value.rating)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "mx-2" }, "·", -1)),
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                                return _createElementVNode("span", {
                                  key: i,
                                  class: "material-symbols-outlined",
                                  style: _normalizeStyle({ fontSize: '15px', color: i <= selected.value.rating ? '#c9a227' : '#ddd' })
                                }, "star", 4)
                              }), 64))
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_v_sheet, {
                        color: "#f5f7f6",
                        rounded: "",
                        class: "pa-3 mb-4"
                      }, {
                        default: _withCtx(() => [
                          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-1 d-flex align-center" }, [
                            _createElementVNode("span", {
                              class: "material-symbols-outlined mr-1",
                              style: {"font-size":"15px"}
                            }, "help"),
                            _createTextVNode(" SORU ")
                          ], -1)),
                          _createElementVNode("p", _hoisted_24, _toDisplayString(selected.value.question_full || selected.value.question), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_sheet, {
                        color: "#f0f7f4",
                        rounded: "",
                        class: "pa-3"
                      }, {
                        default: _withCtx(() => [
                          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-2 d-flex align-center" }, [
                            _createElementVNode("span", {
                              class: "material-symbols-outlined mr-1",
                              style: {"font-size":"15px"}
                            }, "smart_toy"),
                            _createTextVNode(" MAHAI CEVABI ")
                          ], -1)),
                          (selected.value.answer)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "text-body-2 answer-content",
                                innerHTML: renderMarkdown(selected.value.answer)
                              }, null, 8, _hoisted_25))
                            : (_openBlock(), _createElementBlock("span", _hoisted_26, "Cevap bulunamadı."))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})